import {BankaEntity} from "@/entity/BankaEntity";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import {BankaHesabiTipi} from "@/enum/BankaHesabiTipi";
import {BankaHesabiSahibi} from "@/enum/BankaHesabiSahibi";
import {MuvekkilEntity} from "@/entity/MuvekkilEntity";

export class XmlBankaHesabiEntity {
    id!: number;
    avukat_id!: number;
    iban!: string;
    muvekkil!: MuvekkilEntity;
    para_birimi_id!: number;
    para_birimi!: ParaBirimiEntity;
    isim!: string;
    banka_id!: number;
    banka!: BankaEntity;
    sube_adi!: string;
    hesap_no!: string;
    hesap_tipi !: BankaHesabiTipi;
    varsayilan_banka_hesabi_sahibi!: BankaHesabiSahibi;
}

